<div class="tutorial" [class.tutorial--center]="currentStep === 2">
  <div class="tutorial__header">
    <div class="tutorial__breadcrumbs">
      <span
        class="tutorial__prev-arrow"
        [class.disabled]="currentStep === 1"
        (click)="onPrevStep($event)"
      >
        <span class="sidebar-item-arrow" nz-icon nzType="ng-zorro:prev"></span
      ></span>
      <span class="tutorial__crumb">Step {{ currentStep }}</span>
      <span class="tutorial__divider">/</span>
      <span class="tutorial__steps-total">4</span>
      <span
        class="tutorial__next-arrow"
        [class.disabled]="currentStep === 4"
        (click)="onNextStep($event)"
      >
        <span class="sidebar-item-arrow" nz-icon nzType="ng-zorro:next"></span
      ></span>
    </div>
    <div class="tutorial__close">
      <span nz-icon nzType="close" nzTheme="outline" (click)="onClose()"></span>
    </div>
  </div>

  <div class="tutorial__content-wrapper">
    <div [ngSwitch]="currentStep">
      <ng-container *ngSwitchCase="1">
        <h2 class="tutorial__title">Choose Your Source Schain Side</h2>

        <div class="tutorial__intro">
          <div class="tutorial__text">
            To get started, decide where you want Source Schain matching to
            happen:
          </div>
          <ul class="tutorial__bullets">
            <li class="tutorial__bullet">
              <strong>SSP Side</strong> – Matching will be based on the SSP
              company sending the request.
            </li>
            <li class="tutorial__bullet">
              <strong>DSP Side</strong> – Matching will be based on the DSP
              endpoint the file is applied to. Requests from any SSP will be
              matched once they reach this DSP endpoint.
            </li>
          </ul>
        </div>

        <div class="tutorial__mockup">
          <img
            src="assets/img/tutorial/step_1.jpg"
            alt="Source Schain Step 1"
          />
        </div>

        <div class="tutorial__tip">
          <span class="tutorial__tip-label">Tip:</span>
          You can upload files to both sides and freely switch between SSP Side
          and DSP Side tabs at any time to view or update your lists.
        </div>

        <div class="tutorial__note">
          <div class="tutorial__note-title">Important:</div>
          <ul class="tutorial__note-list">
            <li class="tutorial__note-item">
              You can upload files to both sides, but
              <span
                >only one logic type (SSP or DSP) can be selected per
                endpoint.</span
              >
            </li>
            <li class="tutorial__note-item">
              The active logic is chosen in the
              <span>DSP endpoint settings</span>, and it determines which list
              will be used for matching when bid requests reach that endpoint.
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="2">
        <h2 class="tutorial__title">Upload Your Source Schain File</h2>

        <div class="tutorial__intro">
          <div class="tutorial__text">
            Once you’ve selected the side, click the “+” button to upload your
            file.
          </div>
        </div>

        <div class="tutorial__prepare">
          <div class="tutorial__prepare-title">What to prepare:</div>
          <ul class="tutorial__prepare-list">
            <li class="tutorial__prepare-item">File format: CSV or TXT</li>
            <li class="tutorial__prepare-item">
              Required data: bundle ID, SID, ASI (domain)
            </li>
            <li class="tutorial__prepare-item">{{ maxSizePrepareLine }}</li>
          </ul>
        </div>

        <div class="tutorial__mockup">
          <img
            src="assets/img/tutorial/step_2.jpg"
            alt="Source Schain Step 2"
          />
        </div>

        <div class="tutorial__hint">
          When uploaded, your file becomes available for Source Schain matching
          on the selected side.
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="3">
        <h2 class="tutorial__title">SSP Source Schain</h2>
        <div class="tutorial__subtitle">Activate on DSP Endpoints</div>

        <div class="tutorial__intro">
          <div class="tutorial__finish">To finish the setup:</div>
          <ul class="tutorial__bullets tutorial__bullets--dot">
            <li class="tutorial__bullet">
              Go to the <span>DSP endpoint(s)</span> where you want Source
              Schain matching to run.
            </li>
            <li class="tutorial__bullet">
              Enable the <span>"Source Schain"</span> checkbox.
            </li>
          </ul>
        </div>

        <div class="tutorial__mockup">
          <img
            src="assets/img/tutorial/step_3.jpg"
            alt="Source Schain Step 3"
          />
        </div>

        <div class="tutorial__hint">
          Once saved, SSP Source Schain matching based on the SSP company
          sending the request will be applied.
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="4">
        <h2 class="tutorial__title">DSP Source Schain</h2>
        <div class="tutorial__subtitle">Activate on DSP Endpoints</div>

        <div class="tutorial__intro">
          <div class="tutorial__text">To finish the setup:</div>
          <ul class="tutorial__bullets tutorial__bullets--dot">
            <li class="tutorial__bullet">
              Go to the <span>DSP endpoint(s)</span> where you want Source
              Schain matching to run.
            </li>
            <li class="tutorial__bullet">
              Enable the <span>“Source Schain”</span> checkbox.
            </li>
            <li class="tutorial__bullet">
              In the <span>“Source Schain File”</span> dropdown, select the file
              you want to use for matching.
            </li>
          </ul>
        </div>

        <div class="tutorial__mockup">
          <img
            src="assets/img/tutorial/step_4.jpg"
            alt="Source Schain Step 4"
          />
        </div>

        <div class="tutorial__hint">
          Once saved, DSP Source Schain matching based on the file you select in
          the dropdown menu will be applied.
        </div>
      </ng-container>
    </div>
  </div>

  <div class="tutorial__footer">
    <button
      class="tutorial__back"
      type="button"
      (click)="onPrevStep($event)"
      *ngIf="currentStep > 1"
    >
      Back
    </button>
    <button
      class="tutorial__next"
      type="button"
      (click)="currentStep === 4 ? onClose() : onNextStep($event)"
    >
      {{ currentStep === 4 ? "Close" : "Next" }}
    </button>
  </div>
</div>
